<template>
  <div 
    class="flex items-center justify-between p-2 sm:p-4 relative group rounded-b-lg overflow-y-visible"
    @mouseenter="showHoverButtons = true"
    @mouseleave="showHoverButtons = false"
    @click="$emit('listclick')"
    :class="[bgClass, cursorClass]">

    <!-- Left Icon (Radio Buttons) -->
    <div v-if="editmode" class="flex-shrink-0 mr-4 text-skin-b-list-mute">
      <component :is="itemdata.isDLM ? 'IconRadioChecked' : 'IconRadioUnchecked'" class="m-2 w-8 h-8" />
    </div>
    
    <!-- Left Icon (Main Icon based on type) -->
    <div class="flex-shrink-0 mr-4 rounded-lg border border-slate-300" :class="statusBgClass">
      <p class="w-12 h-12 px-1 py-2.5 text-center">
          <span v-if="itemdata.wallboxStatus=='loading'" class="text-lg font-semibold text-white">{{ $n( itemdata.dlm?.totalPower ?? 0, 'decimal1' ) }}</span>

      </p>
      <!--
      <component :is="iconComponent" :fill="itemdata.color" 
      :class="[iconComponent=='IconCar' ? 'm-1 w-10 h-10' : 'm-2 w-8 h-8' ]"
       />-->

    </div>

    <!-- Middle Section: Title and Status -->
    <div class="flex-grow">
      <div class="mb-1 sm:mb-2">
        <strong class="inline-flex items-center gap-1">
           <IconCrown  v-if="itemdata.serial==this.$store.state.WbLogSerial" class="w-4 h-4" />
          {{ itemdata.name }}
        </strong>
         <!--  
        &nbsp;
        <ListItemBadge v-if="statusBadge" :color="statusBadge.color">{{ statusBadge.label }}</ListItemBadge>-->
      </div>
      <div>
        <!-- 
        <span class="text-skin-b-list-mute">
          <component
            :is="rfidIconComponent" :class="rfidIconClass"
            v-if="rfidIconComponent"
            class="inline-block"
          />
          &nbsp;{{ itemdata.info }}
        </span>-->
        <span class="text-skin-b-list-mute">
          {{ $t(`status.${itemdata.wallboxStatus}`) }}
        </span>
        <span v-if="itemdata.wallboxStatus=='loading'" class="hidden sm:inline-block">

          &nbsp;&nbsp;&#8231;&nbsp;
          <IconBolt class="inline-block -mt-1 w-5 h-5" />
              <!--    {{ $t('seteasybalance.powerkw', { Energy: $n( itemdata.dlm?.totalPower ?? 0, 'decimal', { minimumFractionDigits: 1, maximumFractionDigits: 2 } ) } ) }}-->
        </span>
          <!--
        <span v-if="itemdata.wallboxStatus=='loading'&&itemdata.dlm?.setPointNoOfPhases==1" class="hidden sm:inline-block">
          &nbsp;({{ $t('main.optchargepower_b', { phase: itemdata.dlm?.setPointNoOfPhases } ) }})
        </span>-->
        <span v-if="itemdata.wallboxStatus=='loading'" class="hidden sm:inline-block"> 
          &nbsp;
          L1: {{ $t('seteasybalance.powerkw', { Energy: $n( (itemdata.dlm?.powerL1 ?? 0)/1000000, 'decimal', { minimumFractionDigits: 0, maximumFractionDigits: 1 } ) } ) }}
          &nbsp;|
        </span>
        <span v-if="itemdata.wallboxStatus=='loading'" class="hidden sm:inline-block"> 
          &nbsp;
          L2: {{ $t('seteasybalance.powerkw', { Energy: $n( (itemdata.dlm?.powerL2 ?? 0)/1000000, 'decimal', { minimumFractionDigits: 0, maximumFractionDigits: 1 } ) } ) }}
          &nbsp;|
        </span>
        <span v-if="itemdata.wallboxStatus=='loading'" class="hidden sm:inline-block"> 
          &nbsp;
          L3: {{ $t('seteasybalance.powerkw', { Energy: $n( (itemdata.dlm?.powerL3 ?? 0)/1000000, 'decimal', { minimumFractionDigits: 0, maximumFractionDigits: 1 } ) } ) }}
        </span>
      </div>
    </div>

    <!-- Right Buttons -->
    <div v-if="!editmode&&buttonsvisible" class="flex items-center relative">
      <div v-if="showHoverButtons && !isDropdownVisible" class="hidden absolute right-11 top-1/2 transform -translate-y-1/2 z-10 sm:flex sm:items-center">
        <ButtonSmallIcon v-for="(btn, index) in filteredHoverButtons" :key="index" :border="index === 0 ? 'left' : ''" :hovercolor="btn.color" @click="btn.onClick">
          <component :is="btn.icon" class="w-6 h-6" />
        </ButtonSmallIcon>
      </div>

      <!-- Dropdown Button -->
      <div v-if="buttonsvisible" class="relative">
        <button type="button" class="inline-flex items-center px-2 py-1 border-2 border-transparent focus:ring-0 focus:ring-transparent" :class="dropdownClass" @click.stop="toggleDropdown">
          <component :is="isDropdownVisible ? 'IconClose' : 'Icon3Dots'" class="w-6 h-6" />
        </button>
        <ListItemDropdown v-if="isDropdownVisible" class="top-full z-50" :items="filteredHoverButtons" @close="isDropdownVisible = false" />
      </div>
    </div>
  </div>
</template>

<script>
import ListItemDropdown from './ListItemDropdown.vue'
import ListItemBadge from './ListItemBadge.vue'
import ButtonSmallIcon from './ButtonSmallIcon.vue'
import Icon3Dots from '../icons/Icon3Dots.vue'
import IconRadioChecked from '../icons/IconRadioChecked.vue'
import IconRadioUnchecked from '../icons/IconRadioUnchecked.vue'
import IconCar from '../icons/IconCar.vue'
import IconIdCard from '../icons/IconIdCard.vue'
import IconGroups from '../icons/IconGroups.vue'
import IconLockCable from '../icons/IconLockCable.vue'
import IconLearnRfid from '../icons/IconLearnRfid.vue'
import IconSolarPower from '../icons/IconSolarPower.vue'
import IconRfidToken from '../icons/IconRfidToken.vue'
import IconRfidLock from '../icons/IconRfidLock.vue'
import IconRfidLockOpen from '../icons/IconRfidLockOpen.vue'
import IconRfidLockNot from '../icons/IconRfidLockNot.vue'
import IconCopy from '../icons/IconCopy.vue'
import IconBolt from '../icons/IconBolt.vue'
import IconEdit from '../icons/IconEdit.vue'
import IconShare from '../icons/IconShare.vue'
import IconDelete from '../icons/IconDelete.vue'
import IconBlock from '../icons/IconBlock.vue'
import IconCheck from '../icons/IconCheck.vue'
import IconClose from '../icons/IconClose.vue'
import IconCrown from '../icons/IconCrown.vue'
import { useI18n } from 'vue-i18n'

export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },
  components: { ListItemDropdown, ListItemBadge, ButtonSmallIcon, 
                Icon3Dots, IconRadioChecked, IconRadioUnchecked,
                IconCar, IconIdCard, IconGroups, IconLockCable, IconLearnRfid, IconSolarPower,
                IconRfidToken, IconRfidLock, IconRfidLockOpen, IconRfidLockNot, IconCopy, IconBolt,
                IconEdit, IconShare, IconDelete, IconBlock, IconCheck, IconClose, IconCrown 
              },
  emits: ['listclick'],
  props: {
    editmode: Boolean,
    buttonsvisible: Boolean,
    itemdata: { type: Object, default: () => ({}) },
    hoverButtons: { type: Array, default: () => [] },
  },
  data() {
    return {
      isDropdownVisible: false,
      showHoverButtons: false,
    };
  },
  computed: {
    rfidIconClass() {
      const key = this.itemdata.key;
      if (key === '' || key === '##OFF##' || key === '##KEY##') return 'text-skin-b-list-mute -mt-1 w-5 h-5';
      if (key === '##NO_DESFIRE##') return 'text-red-600 -mt-1 w-5 h-5';
      if (key === '##PENDING##') return 'text-amber-600 -mt-1 w-5 h-5';
      return '';
    },
    rfidIconComponent() {
      const map = {
        '': 'IconRfidToken',
        '##OFF##': 'IconRfidToken',
        '##NO_DESFIRE##': 'IconRfidLockNot',
        '##PENDING##': 'IconRfidLockOpen',
        '##KEY##': 'IconRfidLock'
      };
      return map[this.itemdata.key] || null;
    },
    bgClass() {
      return (this.editmode && this.itemdata.isDLM) || this.isDropdownVisible ? 'bg-skin-active128/5' : '';
    },
    cursorClass() {
      return this.editmode ? 'cursor-pointer hover:bg-skin-active128/5' : '';
    },
    iconBgClass() {
      return (this.editmode && this.itemdata.isDLM) || this.isDropdownVisible ? 'bg-skin-active128/10' : 'bg-slate-100';
    },
    statusBgClass() {
      const defaultClass = (this.editmode && this.itemdata.isDLM) || this.isDropdownVisible
        ? 'bg-skin-active128/10'
        : 'bg-slate-100';

      const map = {
        '': defaultClass,
        'unknown': defaultClass,
        'booting': defaultClass,
        'idle': 'bg-[rgb(34,197,94)]',
        'wait_unlock': 'bg-[rgb(234,179,8)]',
        'connected': 'bg-[rgb(234,179,8)]',
        'auth_ok': 'bg-[rgb(255,255,255)]',        
        'loading': 'bg-[rgb(59,130,246)]',
        'loading_paused': 'bg-[rgb(59,130,246)]',
        'loading_done': 'bg-[rgb(59,130,246)]',
        'loading_planned': 'bg-[rgb(139,92,246)]',
        'error': 'bg-[rgb(239,68,68)]',
        'no_connection': 'bg-[rgb(239,68,68)]',
      };

      const status = this.itemdata.wallboxStatus || 'unknown';
      return map[status] || null;
    },
    dropdownClass() {
      return this.showHoverButtons && !this.isDropdownVisible ? 'sm:text-skin-b-list-base sm:bg-skin-b-list-back sm:hover:bg-skin-b-back border-2 sm:border-skin-b-list-bord sm:rounded-r-md' : 'text-skin-b-list-mute bg-transparent';
    },
    iconComponent() {
      const iconMap = {
        rfid: 'IconCar',
        rfid_checkin: 'IconIdCard',
        rfid_user: 'IconGroups',
        rfid_local: 'IconCar',
        fc_rfid_lock: 'IconLockCable',
        fc_rfid_pair: 'IconLearnRfid',
        fc_rfid_charge: 'IconSolarPower',
      };
      return iconMap[this.itemdata.typ] || 'IconCar';
    },
    itemLabels() {
      return {
        rfid_checkin: this.$t('pairing.itemeci'),
        rfid_local: this.$t('pairing.itemlocal'),
        fc_rfid_charge: this.$t('pairing.itemcharge'),
        fc_rfid_lock: this.$t('pairing.itemlock'),
        fc_rfid_pair: this.$t('pairing.itemlearn'),
      };
    },
    statusBadge() {
      if (!this.itemdata.wallboxStatus) return null;
      const statusMap = {
        idle: { color: 'green', label: this.itemdata.wallboxStatus },
        disabled: { color: this.itemdata.typ === 'rfid_checkin' ? 'amber' : 'red', label: this.itemdata.typ === 'rfid_checkin' ? this.$t('pairing.deactiveeci') : this.$t('pairing.deactive') },
      };
      return statusMap[this.itemdata.wallboxStatus];
    },
    filteredHoverButtons() {
      return this.hoverButtons.filter(button => button.show);
    },
  },
  methods: {
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    copyToClipBoard(textToCopy) {
      navigator.clipboard.writeText(textToCopy);
    },
  },
};
</script>
